import { connect } from 'react-redux';
import { preload } from 'react-isomorphic-render';
import _ from 'lodash';
import { fetchManualPage } from 'app/api/product-api';
import ManualPage from 'app/components/product/manual-page';

const mapStateToProps = state => ({
  page: { ..._.get(state, 'product.manualPage') },
});

const ManualPageContainer = connect(mapStateToProps)(preload(
  ({ dispatch }) => dispatch(fetchManualPage()))(ManualPage),
);

export default ManualPageContainer;



// WEBPACK FOOTER //
// ./app/containers/product/manual-page.jsx